<template>
    <div>
        <header v-if="title">
            <h5>
                {{ title }}
            </h5>
        </header>
        <section>
            <slot />
        </section>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: null
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_variables.scss";

    header {
        padding: 13px 13px 13px 20px;
        background: $info-background-color;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border: 1px solid $info-border-color;

        h5 {
            text-transform: uppercase;
            font-weight: 500;
            color: $info-text-color;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
            margin: 0;
        }
    }

    section {
        padding-top: 10px;
        border: 1px solid $content-border-color;
        overflow: hidden;
        position: relative;
    }
</style>
